import { CalculationMethodEnum } from "@app/templates/templateModels";
import SpecialtyDetailFootnote from "@app/projects/results/adequacy/specialtyDetailFootnote";
import { ZipCodeDisplayModel } from "@app/projects/zip-projects/interfaces/zipCodeDisplayModel";
import { ZipCoverageMapDetails, ZipCoverageMapSelections } from "@app/projects/zip-projects/maps/interfaces";

// String fields from the real footnote, metrics from the real zip-analysis row; anything absent stays null (the
// bar renders "---"). Calc method blanks distance/time the project doesn't calculate.
export function buildZipCoverageMapDetails(
  row: ZipCodeDisplayModel | null,
  footnote: SpecialtyDetailFootnote | null,
  applied: ZipCoverageMapSelections,
  calculationMethod: CalculationMethodEnum,
): ZipCoverageMapDetails {
  const isTimeOnly = calculationMethod === CalculationMethodEnum.Time;
  const isDistanceOnly = calculationMethod === CalculationMethodEnum.Distance;

  return {
    averageDistance: isTimeOnly ? null : row?.averageDistance ?? null,
    averageTime: isDistanceOnly ? null : row?.averageTime ?? null,
    entityType: footnote?.entityType ?? null,
    inZipServicingProviderCount: row?.inZipProviderCount ?? null,
    maxDistance: isTimeOnly ? null : row?.maxDistance ?? null,
    maxTime: isDistanceOnly ? null : row?.maxTime ?? null,
    membersWithAccess: row?.memberCountWithAccess ?? null,
    membersWithAccessPercent: row?.withAccessPercent ?? null,
    membersWithoutAccess: row?.memberCountWithoutAccess ?? null,
    membersWithoutAccessPercent: row?.withoutAccessPercent ?? null,
    minimumDistancePhrase: footnote?.minimumDistancePhrase ?? null,
    minimumProviderCount: footnote?.minimumProviderCount ?? null,
    passPercentage: footnote?.passPercentage ?? null,
    primaryCounty: row?.county ?? applied.serviceArea.countyName ?? null,
    servicingProviderCount: row?.providerCount ?? null,
    specialtyGroupName: footnote?.specialtyGroupName || applied.specialtyGroupCode.name,
    state: row?.stateName ?? applied.serviceArea.stateName ?? null,
    totalMembers: row?.membershipCount ?? null,
    zipClass: footnote?.geographyClass ?? null,
    zipCode: applied.serviceArea.zipCode,
    zipName: row?.city ?? null,
  };
}
